import { render, staticRenderFns } from "./LatestDonation.vue?vue&type=template&id=291072da"
import script from "./LatestDonation.vue?vue&type=script&lang=js"
export * from "./LatestDonation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports